import { ReactNode, useEffect, useState } from 'react';

interface IProps {
  icon?: ReactNode;
  onUnderageChange?: (isUnderage: boolean) => void;
  defaultValue?: string;
}

function toDisplayBirthday(value?: string): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) return trimmed;
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function calcAge(day: number, month: number, year: number): number {
  const today = new Date();
  const birth = new Date(year, month - 1, day);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age -= 1;
  return age;
}

export function calcAgeFromBirthdayString(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(trimmed);
  if (!match) return null;

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const birth = new Date(year, month - 1, day);
  if (
    birth.getFullYear() !== year
    || birth.getMonth() !== month - 1
    || birth.getDate() !== day
  ) {
    return null;
  }

  return calcAge(day, month, year);
}

export function isUnderageBirthday(value: string): boolean {
  const age = calcAgeFromBirthdayString(value);
  return age != null && age < 18;
}

export default function BirthdayInput({ icon = null, onUnderageChange, defaultValue }: IProps) {
  const [value, setValue] = useState(() => toDisplayBirthday(defaultValue));
  const isUnderage = isUnderageBirthday(value);

  useEffect(() => {
    onUnderageChange?.(isUnderageBirthday(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatDate = (str: string) => {
    const digits = str.replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDate(e.target.value);
    setValue(formatted);
    onUnderageChange?.(isUnderageBirthday(formatted));
  };

  return (
    <div className="birthday_field">
      <div className="form_item">
        {icon}
        <input
          name="birthdayDate"
          type="text"
          placeholder="Ngày/tháng/năm sinh"
          value={value}
          onChange={handleChange}
          maxLength={10}
          required
        />
      </div>
      {isUnderage && (
        <p className="birthday_warning">
          Bạn chưa đủ 18 tuổi để tham gia trò chơi
        </p>
      )}
    </div>
  );
}
